"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _dexie = _interopRequireDefault(require("dexie"));
/* eslint-disable promise/no-nesting */

var conversionNo = 1000;
var DB_VERSION_THREE = 3;
var DB_VERSION_FOUR = 4;
var DB_VERSION_FIVE = 5;
var DB_VERSION_SIX = 6;
var InterventionDatabase = exports.default = /*#__PURE__*/function () {
  function InterventionDatabase() {
    (0, _classCallCheck2.default)(this, InterventionDatabase);
    this.db = new _dexie.default('intelliChat');
    this.db.version(1).stores({
      interventions: 'userId,uniqueId,interventionId,itemId,timestamp',
      interventionData: 'id,type,priority'
    });
    this.db.version(2).stores({
      interventions: null,
      interventionData: 'id,type,priority'
    });
    this.db.version(DB_VERSION_THREE).stores({
      interventions: '[userId+itemId],uniqueId,userId,interventionId,itemId,timestamp',
      interventionData: 'id,type,priority'
    });
    this.db.version(DB_VERSION_FOUR).stores({
      interventions: null,
      interventionData: 'id,type,priority'
    });
    this.db.version(DB_VERSION_FIVE).stores({
      interventions: 'userItemId,uniqueId,userId,interventionId,itemId,timestamp',
      interventionData: 'id,type,priority'
    }).upgrade(function (trans) {
      trans.interventions.toCollection().modify(function (intervention) {
        intervention.userItemId = "".concat(intervention.userId, "_").concat(intervention.itemId);
      });
    });
    this.db.version(DB_VERSION_SIX).stores({
      interventions: 'userItemId,uniqueId,userId,interventionId,itemId,timestamp',
      interventionData: 'id,type,priority',
      systemMessageData: 'id,subtype'
    });
    this.db.open().catch(
    // eslint-disable-next-line handle-callback-err, no-unused-vars
    function (error) {
      // window.newrelic?.addPageAction('intervention_db_open', {
      //     error
      // });
    });
  }
  (0, _createClass2.default)(InterventionDatabase, [{
    key: "saveInterventionIdData",
    value: function saveInterventionIdData(id, data) {
      data.id = id;
      return this.db.interventionData.put(data);
    }
  }, {
    key: "saveInterventionsData",
    value: function saveInterventionsData(data) {
      var _this = this;
      if (data.length) {
        var obj = {};
        var promiseArr = [];
        data.forEach(function (intervention) {
          if (!intervention) {
            return;
          }
          var id = intervention.id.toString();
          var data = {
            type: intervention.type,
            shownWindow: intervention.display_screen,
            text: intervention.display_text || '',
            actions: intervention.actions,
            priority: intervention.priority,
            invalidateConditions: intervention.remove_conditions,
            icon: intervention.icon
          };
          obj[id] = data;
          promiseArr.push(_this.saveInterventionIdData(id, data).catch(function () {}));
        });
        return _dexie.default.Promise.all(promiseArr).then(function () {
          return obj;
        }).catch(function () {});
      }
      return Promise.resolve([]);
    }
  }, {
    key: "getInterventionsData",
    value: function getInterventionsData() {
      return this.db.interventionData.toArray().then(function (dataArr) {
        var obj = {};
        dataArr.forEach(function (data) {
          obj[data.id] = data;
        });
        return obj;
      });
    }
  }, {
    key: "getUserIntervention",
    value: function getUserIntervention(userId, itemId) {
      return this.db.interventions.where('userItemId').equals("".concat(userId, "_").concat(itemId)).toArray();
    }
  }, {
    key: "getInterventionIdData",
    value: function getInterventionIdData(id) {
      return this.db.interventionData.where('id').equals(id).toArray();
    }
  }, {
    key: "getRemoveConditions",
    value: function getRemoveConditions(id) {
      return this.db.interventionData.where('id').equals(id).toArray().then(function (data) {
        return data[0] && data[0].invalidateConditions;
      });
    }
  }, {
    key: "saveIntervention",
    value: function saveIntervention(message, date) {
      var _this2 = this;
      var msg = message.intervention;
      var userId = msg.userId && msg.userId.split('_')[0];
      var interventionId = msg.interventionId;
      return this.getUserIntervention(userId, message.extras.itemId).then(function (intervention) {
        var oldIntervention = intervention[0];
        return _this2.getInterventionIdData(interventionId).then(function (data) {
          if (data.length) {
            var interventionData = data[0];
            var priority = interventionData.priority;
            var expiry = interventionData.invalidateConditions && interventionData.invalidateConditions.expiry_time;
            var params = {};
            var trackObj = [];
            if (msg.price) {
              params.price = msg.price;
            }
            if (!oldIntervention || priority && priority < oldIntervention.priority || message.extras.itemId !== intervention[0].itemId) {
              return _this2.db.interventions.put({
                uniqueId: "".concat(userId, "_").concat(message.extras.itemId, "_").concat(interventionId),
                interventionId: interventionId,
                userId: userId,
                itemId: message.extras.itemId,
                timestamp: date,
                params: params,
                priority: priority,
                userItemId: "".concat(userId, "_").concat(message.extras.itemId),
                expiry: expiry && date + expiry * conversionNo || '',
                id: message.id
              }).then(function () {
                if (intervention.length) {
                  trackObj.push({
                    event: 'item_chat_interv_invalidated',
                    data: {
                      intervention_id: oldIntervention.interventionId,
                      interv_msg_id: oldIntervention.id,
                      item_id: oldIntervention.itemId
                    }
                  });
                }
                trackObj.push({
                  event: 'item_chat_interv_received',
                  data: {
                    intervention_id: msg.interventionId,
                    interv_msg_id: message.id,
                    item_id: message.extras.itemId
                  }
                });
                return trackObj;
              });
            }
          }
          throw new Error();
        });
      });
    }
  }, {
    key: "updateInterventionSeenData",
    value: function updateInterventionSeenData(userId, itemId, obj) {
      var data = {
        seen: obj
      };
      return this.db.interventions.update([userId, itemId], data);
    }
  }, {
    key: "getActiveInterventions",
    value: function getActiveInterventions() {
      return this.db.interventions.toArray().then(function (dataArr) {
        var obj = {};
        dataArr.forEach(function (data) {
          obj["".concat(data.userId, "_").concat(data.itemId)] = data;
        });
        return obj;
      });
    }
  }, {
    key: "removeIntervention",
    value: function removeIntervention(userId, itemId, id) {
      return this.db.interventions.where('uniqueId').equals("".concat(userId, "_").concat(itemId, "_").concat(id)).delete();
    }
  }, {
    key: "removeUserIntervention",
    value: function removeUserIntervention(userId, itemId) {
      return this.db.interventions.where('userItemId').equals("".concat(userId, "_").concat(itemId)).delete();
    }
  }, {
    key: "clear",
    value: function clear() {
      return this.db.interventions.clear();
    }
  }, {
    key: "saveSystemMessageIdData",
    value: function saveSystemMessageIdData(id, data) {
      data.id = id;
      return this.db.systemMessageData.put(data);
    }
  }, {
    key: "saveSystemMessageData",
    value: function saveSystemMessageData(data) {
      var _this3 = this;
      if (data.length) {
        var obj = {};
        var promiseArr = data.map(function (msg) {
          if (!msg) {
            return;
          }
          var id = msg.id;
          var data = {
            actionLabel: msg.action_label,
            body: msg.body,
            layout: msg.layout,
            subtitle: msg.subtitle,
            new_title: msg.new_title,
            append_logo: msg.append_logo,
            subtype: msg.subtype,
            title: msg.title,
            useDefault: msg.use_default,
            icon: msg.icon,
            deeplinks: msg.deeplinks
          };
          obj[id] = data;
          _this3.saveSystemMessageIdData(id, data).catch(function () {});
        });
        return _dexie.default.Promise.all(promiseArr).then(function () {
          return obj;
        }).catch(function () {});
      }
      return Promise.resolve([]);
    }
  }, {
    key: "getSystemMessageData",
    value: function getSystemMessageData() {
      return this.db.systemMessageData.toArray().then(function (dataArr) {
        var obj = {};
        dataArr.forEach(function (data) {
          obj[data.id] = data;
        });
        return obj;
      });
    }
  }]);
  return InterventionDatabase;
}();